"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LifeBelowWater = void 0;
var React = __importStar(require("react"));
var LifeBelowWater = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "48",
    height: "48",
    viewBox: "0 0 544.2 604"
  }, React.createElement("g", null, React.createElement("g", {
    transform: "translate(0.000000, -1.000000)"
  }, React.createElement("g", {
    transform: "translate(0.000000, 0.035047)"
  }, React.createElement("path", {
    fill: "#0076B7",
    d: "M400,482.1c13.4,0,24.2-10.8,24.2-24.2c0-13.3-10.8-24.1-24.2-24.1\n        c-13.3,0-24.1,10.8-24.1,24.1C375.8,471.2,386.6,482.1,400,482.1z M504.8,470.8c0.3,0.3,0.5,0.6,0.6,0.8c0.1,0.3,0.2,0.6,0.2,0.9\n        c0,0.3-0.1,0.6-0.2,0.9c-0.2,0.2-0.4,0.5-0.6,0.8c-9.1,12.3-68.1,87.6-150.8,87.6c-71.8,0-148.6-65.2-148.6-65.2\n        s-29,59.3-88.2,64.8c-0.2,0.1-0.4,0.1-0.6,0.1l-0.6,0.1c-1.2-0.1-2.2-1.1-2.2-2.3c0-0.5,0.1-0.9,0.4-1.2l0.5-0.8\n        c7.5-12.6,27.1-48.7,27.1-84.7c0-35.9-19.4-71.9-27-84.6c0,0-0.8-1.1-0.9-2.2c-0.1-1.1,1-2.3,2.3-2.3h0.4c0.4,0,0.8,0.1,1.1,0.1\n        c59,5.7,87.9,64.8,87.9,64.8s76.8-65.2,148.6-65.2C436.7,383.2,495.6,458.4,504.8,470.8z"
  }), React.createElement("path", {
    fill: "#0076B7",
    d: "M200,315.7c0.2-0.3,0.4-0.5,0.6-0.7c0.4-0.2,0.8-0.4,1.3-0.4c0.6,0,1.2,0.3,1.6,0.7l0.1,0.1\n        c45.1,43,92.4,8.2,102.2,0l1-0.9c0.3-0.1,0.6-0.1,0.9-0.1s0.7,0,1,0.1l1,0.9c9.8,8.2,57.1,43,102.2,0c0,0,0-0.1,0.1-0.1\n        c0.4-0.4,1-0.7,1.6-0.7c0.5,0,0.9,0.2,1.3,0.4c0.3,0.2,0.5,0.4,0.7,0.7c8.7,8.6,46.5,41.2,86.4,6.4c0.4-0.4,0.7-1,0.7-1.7v-16.5\n        c0-1.3-1.1-2.4-2.4-2.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0.2-0.8,0.4-1.2,0.6c-12.3,6.2-50.4,20.8-84.9-11.9c-0.3-0.3-0.7-0.6-1-0.9\n        c-0.3-0.2-0.6-0.2-1-0.2c-0.2,0-0.5,0.1-0.7,0.2c-0.5,0.1-0.9,0.5-1.2,0.9c-10.3,7.9-57.6,39.9-99.7,0.6l-0.6-0.6\n        c-0.4-0.4-1-0.7-1.7-0.7c-0.6,0-1.2,0.2-1.6,0.7l-0.7,0.6c-42.1,39.3-89.4,7.3-99.7-0.6c-0.3-0.4-0.7-0.8-1.2-0.9\n        c-0.2-0.1-0.5-0.2-0.8-0.2s-0.7,0.1-1,0.2c-0.3,0.3-0.7,0.6-1,0.9c-34.6,32.7-72.6,18.1-84.9,11.9c-0.4-0.2-0.8-0.4-1.2-0.6\n        c-0.2,0-0.3-0.1-0.5-0.1c-1.3,0-2.4,1-2.4,2.4v16.5c0,0.7,0.3,1.2,0.7,1.7C153.4,356.8,191.2,324.3,200,315.7"
  }), React.createElement("path", {
    fill: "#0076B7",
    d: "M115.6,241.6c-0.2,0-0.3-0.1-0.5-0.1c-1.3,0-2.4,1.1-2.4,2.4v16.5c0,0.7,0.3,1.3,0.7,1.7\n        c39.9,34.7,77.7,2.2,86.5-6.4c0.2-0.3,0.4-0.5,0.6-0.7c0.4-0.3,0.8-0.4,1.3-0.4c0.6,0,1.2,0.2,1.6,0.6l0.1,0.1\n        c45.1,43.1,92.4,8.2,102.2,0l1-0.9c0.3-0.1,0.6-0.2,0.9-0.2s0.7,0,0.9,0.2l1,0.9c9.8,8.2,57.1,43.1,102.2,0l0.1-0.1\n        c0.4-0.4,1-0.6,1.6-0.6c0.5,0,0.9,0.2,1.3,0.4c0.3,0.2,0.5,0.4,0.7,0.7c8.7,8.6,46.5,41.1,86.4,6.4c0.4-0.4,0.7-1,0.7-1.7v-16.5\n        c0-1.3-1-2.4-2.3-2.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0.2-0.8,0.4-1.2,0.6c-12.3,6.2-50.3,20.8-84.9-11.9c-0.3-0.3-0.7-0.6-1-1\n        c-0.3-0.1-0.6-0.2-1-0.2c-0.2,0-0.5,0.1-0.7,0.1c-0.5,0.2-0.9,0.5-1.2,0.9c-10.3,7.9-57.6,39.9-99.7,0.6l-0.6-0.6\n        c-0.4-0.4-1-0.7-1.7-0.7c-0.6,0-1.2,0.3-1.6,0.7l-0.7,0.6c-42.1,39.3-89.4,7.3-99.7-0.6c-0.3-0.4-0.7-0.7-1.2-0.9\n        c-0.2,0-0.5-0.1-0.8-0.1s-0.7,0.1-1,0.2c-0.3,0.4-0.7,0.7-1,1c-34.6,32.7-72.6,18.1-84.9,11.9C116.4,242,116,241.8,115.6,241.6"
  }), React.createElement("polygon", {
    fill: "#0076B7",
    points: "42.3,1.9 42.3,148.3 17.7,148.3 17.7,36.2 17.5,36.2 0.2,54.1 0,54.1 0,28.4 \n        22.7,1.9"
  }), React.createElement("path", {
    fill: "#0076B7",
    d: "M76.1,105.3l22-60.3h0.2v60.3H76.1z M121.2,148.3v-23.8h9.9v-19.2h-9.9V1.8H97L54.5,109.4\n        v15.1h43.4v23.8H121.2z"
  }), React.createElement("polygon", {
    fill: "#0076B7",
    points: "184.7,1 195,1 195,53.9 207.2,53.9 207.2,62.3 184.7,62.3"
  }), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#0076B7",
    points: "211.9,62.3 222.2,62.3 222.2,1 211.9,1"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#0076B7",
    points: "228.2,1 252.2,1 252.2,9.4 238.4,9.4 238.4,26.9 248.7,26.9 248.7,35.3 \n          238.4,35.3 238.4,62.3 228.2,62.3"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#0076B7",
    points: "256.7,1 281.3,1 281.3,9.4 267,9.4 267,26.9 277.2,26.9 277.2,35.3 267,35.3 \n          267,53.9 281.3,53.9 281.3,62.3 256.7,62.3"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#0076B7",
    d: "M195,120.5v19.1h4.5c3.4,0,5.1-1.7,5.1-5v-9.1c0-3.3-1.5-5-5.1-5H195z M195,112.6h3.6\n          c3.3,0,4.9-1.7,4.9-5v-7.5c0-3.3-1.5-5-5-5H195V112.6z M184.7,86.8h14.9c10.3,0,13.7,4.8,13.7,13.5v6.2c0,5.2-1.9,8.4-6.1,9.8\n          c5.1,1.2,7.7,4.6,7.7,10.2v8.1c0,8.7-3.9,13.5-14.2,13.5h-16L184.7,86.8L184.7,86.8z"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#0076B7",
    points: "220,86.8 244.5,86.8 244.5,95.2 230.2,95.2 230.2,112.7 240.4,112.7 240.4,121 \n          230.2,121 230.2,139.6 244.5,139.6 244.5,148 220,148"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#0076B7",
    points: "250,86.8 260.3,86.8 260.3,139.6 272.5,139.6 272.5,148 250,148"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#0076B7",
    d: "M297.6,133.9V101c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3v32.9\n          c0,3.7,1.6,6.3,5.2,6.3C296,140.2,297.6,137.6,297.6,133.9 M276.8,132.2v-29.6c0-9.6,4.7-16.5,15.5-16.5\n          c10.9,0,15.6,7,15.6,16.5v29.6c0,9.5-4.7,16.5-15.6,16.5C281.4,148.8,276.8,141.7,276.8,132.2"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#0076B7",
    points: "335,110.2 329.2,148 319.6,148 311.4,86.8 321.3,86.8 326.1,125.6 326.2,125.6 \n          331.3,86.8 339.7,86.8 345.4,125.6 345.5,125.6 350.2,86.8 358.8,86.8 350.9,148 341.1,148 335.1,110.2"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#0076B7",
    points: "394.9,110.2 389.1,148 379.5,148 371.2,86.8 381.2,86.8 385.9,125.6 386,125.6 \n          391.2,86.8 399.6,86.8 405.2,125.6 405.3,125.6 410,86.8 418.7,86.8 410.7,148 401,148 395,110.2"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#0076B7",
    d: "M430.8,128.6h8.2l-4.1-24.6h-0.1L430.8,128.6z M417.9,148l11.5-61.2h11.7l11.6,61.2h-10.6\n          l-1.9-11.2h-10.9l-1.8,11.2H417.9z"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#0076B7",
    points: "451.3,86.8 478.6,86.8 478.6,95.2 470.2,95.2 470.2,148 459.8,148 459.8,95.2 \n          451.3,95.2"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#0076B7",
    points: "483.4,86.8 507.9,86.8 507.9,95.2 493.7,95.2 493.7,112.7 503.9,112.7 503.9,121 \n          493.7,121 493.7,139.6 507.9,139.6 507.9,148 483.4,148"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#0076B7",
    d: "M523.7,95.2v19.1h3.4c3.5,0,5.1-1.8,5.1-5.1v-9c0-3.3-1.5-5-5.1-5H523.7z M523.7,120v28.1\n          h-10.3V86.9h15c10.4,0,14.2,5.1,14.2,13.7v7.9c0,6.6-2.3,10.5-8.2,11.8l9.8,27.8h-10.8L523.7,120z"
  }))))));
};
exports.LifeBelowWater = LifeBelowWater;